import useTranslation from 'next-translate/useTranslation';
import { Flex } from '@mantine/core';
import type { ContestSettings } from '@betterpool/api-types';

import { Text } from '~/domains/design-system/Text';
import { CurrencyConvertor } from '~/components/utils/formatters';
import { BadgeEntryRevival } from '~/components/shared/Badges/Badges';

import { SectionNote } from '../components';

type PrizesEntryRevivalProps = {
  buybackPrizePoolInDollars?: number | null;
  buybackSettings?: ContestSettings['buybacks'];
};

function PrizesEntryRevival({
  buybackPrizePoolInDollars,
  buybackSettings,
}: PrizesEntryRevivalProps) {
  const { t } = useTranslation('contest');

  const isRevivalDeadlinePassed = buybackPrizePoolInDollars && buybackPrizePoolInDollars !== null;

  return (
    <>
      <SectionNote mt={8} mb={4}>
        <Text variant="subhead-small" c="gray.6">
          <Flex align="center" /* eslint-disable-line local-rules/use-theme-tokens */ gap={8}>
            {t('detail.prizes.entryRevival.title')} <BadgeEntryRevival iconSize={24} />
          </Flex>
        </Text>
      </SectionNote>
      {isRevivalDeadlinePassed ? (
        <>
          <SectionNote>
            <Text variant="body-medium">{t('detail.prizes.entryRevival.bonus')}</Text>
            <Text variant="title-small">{CurrencyConvertor(buybackPrizePoolInDollars)}</Text>
          </SectionNote>
          <SectionNote>
            <Text variant="body-medium">{t('detail.prizes.entryRevival.bonusInfo')}</Text>
          </SectionNote>
        </>
      ) : (
        <>
          <SectionNote>
            <Text variant="body-medium">{t('detail.prizes.entryRevival.potentialBonus')}</Text>
            <Text variant="title-small">
              {CurrencyConvertor(buybackSettings?.potentialPrizePoolInDollars || 5000)}
            </Text>
          </SectionNote>
          <SectionNote>
            <Text variant="body-medium">{t('detail.prizes.entryRevival.potentialBonusInfo')}</Text>
          </SectionNote>
        </>
      )}
    </>
  );
}

export default PrizesEntryRevival;
